























































































































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop, Watch} from 'vue-property-decorator';

import {IpSettings} from '@/model/network/settings/IpSettings';
import {IpAddressingMethod} from '@/model/network/IpAddressingMethod';
import {IpMode} from '@/model/network/IpMode';
import {IpAddress} from '@/model/network/IpAddress';

import {BaseComponent} from '@/mixins/BaseComponent';
import {Patterns} from '@/utils/Patterns';

@Component({
  components: {},
})
export default class NetworkIpSettingsEditor extends Mixins<BaseComponent>(BaseComponent) {
  private IpAddressingMethod = IpAddressingMethod;

  private ipMethods = [
    IpAddressingMethod.Auto,
    IpAddressingMethod.Manual,
    IpAddressingMethod.LinkLocal,
    IpAddressingMethod.Disabled,
  ];

  private placeholders: Map<IpMode, any> = new Map([
    [IpMode.IPv4, {
      ip: 'e.g. 192.168.1.50',
      prefix: 'e.g. 24',
      gateway: 'e.g. 192.168.1.1',
      dns: 'e.g. 192.168.1.1',
    }],
    [IpMode.IPv6, {
      ip: 'e.g. ::200',
      prefix: 'e.g. 64',
      gateway: 'e.g. ::1',
      dns: 'e.g. ::1',
    }],
  ]);

  private required = [
    (value: any) => value !== '' || 'Required',
  ];

  private ipRule = [
    (value: any) => value === undefined || value === '' || value.match((this.mode === IpMode.IPv4 ? Patterns.IPv4 : Patterns.IPv6)) || 'This is not a valid IP address',
  ];

  private maskRule = [
    (value: number) => !isNaN(value) || 'Not a number',
    (value: number) => (value >= this.MinPrefix && value <= this.MaxPrefix) || `Not a valid prefix length (${this.MinPrefix} - ${this.MaxPrefix})`,
  ];

  private get MinPrefix(): number {
    return this.mode === IpMode.IPv4 ? 0 : 10;
  }

  private get MaxPrefix(): number {
    return this.mode === IpMode.IPv4 ? 32 : 128;
  }

  @Prop(Object)
  private ipSettings!: IpSettings;

  @Prop({type: String, default: IpMode.IPv4})
  private mode!: IpMode;

  @Prop({type: String, default: null})
  private method!: IpAddressingMethod | null;

  private mounted() {
    this.onIpSettingsChanged();
  }

  @Watch('ipSettings')
  private onIpSettingsChanged() {
    if (this.method) {
      this.ipSettings.Method = this.method;
    }
  }

  @Watch('ipSettings.Method')
  private onMethodChanged() {
    switch (this.ipSettings.Method) {
      case IpAddressingMethod.Manual:
        if (this.ipSettings.Addresses.length === 0) {
          this.addAddress();
        }
    }
  }

  private addAddress() {
    if (!this.ipSettings.Addresses) {
      this.ipSettings.Addresses = [];
    }

    const ip = new IpAddress();
    ip.Address = '';
    ip.PrefixLength = this.mode === IpMode.IPv4 ? 24 : 64;
    this.ipSettings.Addresses.push(ip);
  }

  private eraseAddress(index: number) {
    this.ipSettings.Addresses?.splice(index, 1);
  }

  private addDns() {
    this.ipSettings.Dnss.push('');
  }

  private eraseDns(index: number) {
    this.ipSettings.Dnss.splice(index, 1);
  }
}
